import axios from 'axios';
import Vue from 'vue';
import IdleVue from 'idle-vue';
import VeeValidate from 'vee-validate';
import VueShowdown, { showdown } from 'vue-showdown';
import '@webcomponents/webcomponentsjs/custom-elements-es5-adapter';
import '@webcomponents/webcomponentsjs/webcomponents-bundle';
import '@fmr-pr103625/apexutils-common/dist/utils';
import '@fmr-pr103625/apexutils-event-bus/dist/utils';
import '@fmr-pr103625/apex-address/dist/component-esm';
import '@fmr-pr103625/apex-autocomplete/dist/component-esm';
import '@fmr-pr103625/apex-options-list/dist/component-esm';
import '@fmr-pr103625/apex-date-select/dist/component-esm';
import '@fmr-pr103625/apex-email/dist/esm5/component';
import '@fmr-pr103625/apex-full-name/dist/esm5/component';
import '@fmr-pr103625/apex-page-loading-spinner/dist/component-esm';
import '@fmr-pr103625/apex-phone/dist/component-esm';
import '@fmr-pr103625/apex-select/dist/component-esm';
import '@fmr-pr103625/apex-ssn/dist/component-esm';
import '@fmr-pr103625/apex-toggle/dist/component-esm';
import '@fmr-pr103625/apex-graphical-progress';

import App from './App.vue';
import router from './router';
import store from './store/index';
import dataHelper from './mixins/dataHelper';
import navHelper from './mixins/navHelper';

Vue.config.productionTip = false;

Vue.config.ignoredElements = [
  'footer-simple',
  'header-simple',
  'icon-set',
  'progress-indicator',
  'system-message',
  'perfMark',
];

const veeValidateConfig = {
  aria: true,
  events: 'change',
};

const eventsHub = new Vue();

const options = {
  eventEmitter: eventsHub,
  idleTime: window.sessionTime,
};

Vue.use(VeeValidate, veeValidateConfig);
Vue.use(IdleVue, options);

showdown.setFlavor('original');
showdown.setOption('openLinksInNewWindow', true);
Vue.use(VueShowdown);

new Vue({
  router,
  store,
  mixins: [
    dataHelper,
    navHelper,
  ],
  data() {
    return {
      routeApiCalled: false,
    };
  },
  onIdle() {
    if (!this.uc_isCustomer) {
      this.navigate('session-timeout');
    }
  },
  beforeCreate() {
    const pageReload = 1;
    if (window.params.rt === 'managed' && performance.navigation.type === pageReload) {
      if (window.queries.recordId) {
        this.$router.push({ path: 'retrieve' });
      } else if (localStorage.getItem('transactionContextKey')) {
        const transactionContextKey = localStorage.getItem('transactionContextKey');
        this.$router.push({ path: `/?transactionContextKey=${transactionContextKey}` });
      } else {
        const contextKey = localStorage.getItem('contextKey');
        this.$router.push({ path: `/?contextKey=${contextKey}` });
      }
    }
  },
  created() {
    const { contextKey, transactionContextKey } = this.$route.query;
    const { hash } = document.location;

    const instanceData = {
      routeId: window.params.rt,
      locale: window.params.locale,
      contextKey,
      transactionContextKey,
      queryParams: window.queries,
    };
    if (hash === '#/customer-igo') {
      instanceData.currentState = {
        stateName: 'customer-igo', navAction: '', destinationState: '', editMode: false,
      };
    }
    if (hash === '#/retrieve') {
      instanceData.currentState = {
        stateName: 'retrieve', navAction: '', destinationState: '', editMode: false,
      };
      instanceData.storageInfo = {
        recordId: window.queries.recordId,
        transactionContextKey,
        contextKey,
      };
    }
    if (hash.includes('#/trust-retrieve-page')) {
      instanceData.currentState = {
        stateName: 'trust-retrieve-page', navAction: '', destinationState: '', editMode: false,
      };
      // Extract ceremonyId from hash and store in localStorage
      if (hash.includes('?')) {
        const hashQueryString = hash.split('?')[1];
        const hashParams = new URLSearchParams(hashQueryString);
        const ceremonyId = hashParams.get('ceremonyId');
        if (ceremonyId) {
          localStorage.setItem('ceremonyId', ceremonyId);
          instanceData.ceremonyId = ceremonyId;
        }
      } else {
        // If no ceremonyId in URL, try to get from localStorage
        const storedCeremonyId = localStorage.getItem('ceremonyId');
        if (storedCeremonyId) {
          instanceData.ceremonyId = storedCeremonyId;
        }
      }
    }
    this.setQueryParams(instanceData.queryParams);
    axios.post('api/route', { instanceData }).then((res) => {
      if (res.data?.redirectUrl) {
        window.location.href = res.data.redirectUrl;
        return;
      }
      if (
        res.data.instanceData.routeId === 'managed'
        && res.data.instanceData.referrerContext.acctNum
        && res.data.pageData.tStoreResponse
        && res.data.pageData.tStoreResponse.igoURL
        && res.data.pageData.tStoreResponse.igoURL.url
      ) {
        if (res.data.pageData.tStoreResponse.igoURL.method === 'GET') {
          // Navigate to IGO url
          window.location.href = res.data.pageData.tStoreResponse.igoURL.url;
        } else {
          // Form submit to IGO url
          this.submitForm(this.createForm(res.data.pageData.tStoreResponse.igoURL.url, res.data.pageData.tStoreResponse.params));
        }
      } else if ((!contextKey && !transactionContextKey) && res.data.instanceData.routeId === 'managed' && !res.data.instanceData.storageInfo.recordId) {
        this.navigate('system-error');
      } else {
        if (((contextKey || transactionContextKey) || (res.data && res.data.instanceData && res.data.instanceData.storageInfo
        && res.data.instanceData.storageInfo.recordId)) && res.data && res.data.pageData
        && res.data.pageData.tStoreResponse) {
          this.$globalData.tStoreResponse = res.data.pageData.tStoreResponse;
        }
        this.setRenderData(res.data);
        if (res.data.instanceData.missingRtaz) {
          if (!new URLSearchParams(window.location.search).has('auth_called')) {
            setTimeout(() => {
              const authUrl = `${res.data.instanceData.loginAuthzURL}?AuthOrigUrl=${encodeURIComponent(`${window.location.href}&auth_called=true`)}`;
              window.location.assign(authUrl);
            }, 400);
          } else {
            throw new Error();
          }
        } else {
          if (res.data.instanceData.routeId === 'managed') {
            if (transactionContextKey) {
              localStorage.setItem('transactionContextKey', transactionContextKey);
            } else if (contextKey) {
              localStorage.setItem('contextKey', contextKey);
            }
          }
          this.navigate(res.data.instanceData.currentState.stateName);
        }
      }
    }).catch(() => {
      this.navigate('system-error');
    });
  },
  render: (h) => h(App),
}).$mount('#app');
